import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchCustomTheme } from 'redux/themes/actions';

import { hexToRgba } from 'hex-and-rgba';

import ColorPicker from 'components/dashboard/appearance-content/ColorPicker';
import BackgroundStyleSelector
  from 'components/dashboard/appearance-content/BackgroundStyleSelector';

import BackgroundImageSelector
  from 'components/dashboard/appearance-content/BackgroundImageSelector';
import AnimatedBackgroundSelector from 'components/dashboard/appearance-content/AnimatedBackgroundSelector';

import './BackgroundSelector.css';


class BackgroundSelector extends Component {
  static propTypes = {
    patchCustomTheme: PropTypes.func.isRequired,
    setCustomMode: PropTypes.func.isRequired,
    me: PropTypes.object,
  }

  static defaultProps = {
    me: null,
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.me.custom_theme.background_style !==
        this.props.me.custom_theme.background_style
    ) {
      this.setBackgroundGradient();
    }

    if (
      (prevProps.me.custom_theme.background_color !==
        this.props.me.custom_theme.background_color) &&
      (this.props.me.custom_theme.background_style === 'up' ||
        this.props.me.custom_theme.background_style === 'down')
    ) {
      this.setBackgroundGradient();
    }
  }

  onBackgroundChangeColor = color => {
    if (this.props.me.theme) { this.props.setCustomMode(); }
    this.setBackgroundColor(color);
  };

  setBackgroundColor = color => {
    const { me } = this.props;
    const customThemeId = me && me.custom_theme && me.custom_theme.id;
    const backgroundStyle = me && me.custom_theme && me.custom_theme.background_style;
    const form = new FormData();
    form.append('background_color', color.hex);

    if (backgroundStyle === '') {
      form.append('background_style', 'flat');
    }
    this.props.patchCustomTheme(customThemeId, form);
  };

  setBackgroundGradient = () => {
    const { me } = this.props;
    const customThemeId = me && me.custom_theme && me.custom_theme.id;
    const backgroundStyle = me && me.custom_theme &&
      me.custom_theme.background_style;
    const backgroundColor = me && me.custom_theme &&
      me.custom_theme.background_color;

    const rgbaArray = hexToRgba(backgroundColor);
    const rgba = hexToRgba(backgroundColor).toString();
    const rgba2 = `rgba(${rgbaArray[0]},${rgbaArray[1]},${rgbaArray[2]},${0.5})`;

    const form = new FormData();
    if (backgroundStyle === 'up') {
      form.append(
        'background_gradient',
        `linear-gradient(0deg, ${rgba}, ${rgba2})`,
      );
    }
    if (backgroundStyle === 'down') {
      form.append(
        'background_gradient',
        `linear-gradient(180deg, ${rgba}, ${rgba2})`,
      );
    }
    this.props.patchCustomTheme(customThemeId, form);
  };

  render() {
    const { me } = this.props;
    const backgroundColor = me && me.custom_theme &&
      me.custom_theme.background_color;

    return (
      <Translation>
        {(t) => (
          <div className="background-selector__component">

            {/* Background Style */}
            <div className="section style-wrapper">
              <div className="header">{t("Background Style")}</div>
              <BackgroundStyleSelector
                setCustomMode={this.props.setCustomMode}
              />
            </div>

            {/* Load animated backgraund */}
            <div className="section animated-wrapper">
              <div className="header">{t("Animated Background")}</div>
              <AnimatedBackgroundSelector
                setCustomMode={this.props.setCustomMode}
              />
            </div>

            {/* Background Color */}
            <div className="section color-wrapper">
              <div className="header">{t("Background Color")}</div>
              <ColorPicker
                key="background_color_picker_key"
                pickerId="background_color_picker_id"
                color={backgroundColor}
                onChangeComplete={this.onBackgroundChangeColor}
                disableAlpha
              />
            </div>

            {/* Load Picture */}
            <div className="section load-picture">
              <div className="header">{t("Upload Image")}</div>
              <BackgroundImageSelector
                setCustomMode={this.props.setCustomMode}
              />
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchCustomTheme,
  },
)(BackgroundSelector);
